<template>
    <div>
        <a-menu v-model="current" mode="horizontal">
            <a-menu-item v-for="item in menuList" :key="item.key" :keyPath="item.path" @click="menuClick(item)">
                {{item.name}}

            </a-menu-item>
        </a-menu>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'HeaderMenu',
        data() {
            return {
                current: [],
                menuList: []
            };
        },
        computed: {
            ...mapGetters([
                'getMenuValue'
            ])
        },
        watch: {
            getMenuValue: function (newValue) {
                if (newValue) {
                    this.current = [newValue];
                }
            }
        },
        components: {},
        mounted(){
            this.menuList = this.getMenuList();
            this.matchPath();
        },
        methods: {
            menuClick(item){
                this.$store.dispatch('setMenuValueFunction', item.key);
                this.$router.push(item.path);
            },
            getMenuList(){ //此处到时候可以配合权限接口来做
                let list =
                    [
                        {name: '首页', key: 'sy', path: '/home'},
                        {name: '研修引领', key: 'yxyl', path: '/yxHome'},
                        {name: '课程辅导', key: 'kcfd', path: ''},
                        {name: '学情督导', key: 'xqdd', path: ''},
                        {name: '评价审核', key: 'pjsh', path: ''}
                    ];
                return list;
            },
            matchPath(){
                for (let item of this.menuList) {
                    if (item.path === this.$router.currentRoute.path) {
                        this.current = [item.key];
                        break;
                    }
                }
            }
        }
    }
</script>

<style>

</style>
